export class IdPRolesMappingRequest {
    id: number;
    idpId: number;
    orgAcctNumber: number;
    accountGroups: string;
    serviceId: string;
    serviceRoles: string;
    serviceRolesGroups: string;

    constructor() {
        this.id = 0;
        this.idpId = 0;
        this.orgAcctNumber = 0;
        this.accountGroups = '';
        this.serviceId = '';
        this.serviceRoles = '';
        this.serviceRolesGroups = '';
    }
}